const _customerName = Symbol();
const _doctorName = Symbol();

export class CPMSessionSummary {
	constructor(customerName, doctorName) {
		this.customerName = customerName;
		this.doctorName = doctorName;
	}
	get customerName() {
		return this[_customerName];
	}
	set customerName(v) {
		if(typeof v !== 'string')
			throw new TypeError('customerName must be a string.');
		this[_customerName] = v;
	}
	get doctorName() {
		return this[_doctorName];
	}
	set doctorName(v) {
		if(typeof v !== 'string')
			throw new TypeError('doctorName must be a string.');
		this[_doctorName] = v;
	}
	toJSON() {
		return {
			customerName : this.customerName,
			doctorName: this.doctorName
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			obj.customerName || obj.CustomerName || '',
			obj.doctorName || obj.DoctorName || ''
		);
	}
}